import React, { useState, useEffect, useContext } from "react";
import User, { IUserMessage } from "../../../../services/api/User";
import "./assets/style.css";
import bell from "./assets/images/bell.svg";
import AuthContext from "../../../../contexts/AuthContext";

const Alert: React.FC = () => {
    const { user } = useContext(AuthContext);
    const monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
    const [messages, setMessages] = useState<IUserMessage[]>([]);

    async function LoadMessages() {
        const response: IUserMessage[] = await User.Messages();
        setMessages(response);
    }

    function listMessages(obj: IUserMessage, index: number): any {
        return <li key={index}>
            <a className="alert__notifications--item" href={'/forecast-update/' + obj.id + '/' + obj.year + '/' + obj.month}>
                {obj.name} ({monthShortNames[obj.month-1]}, {obj.year})
            </a>
        </li>;
    }

    useEffect(() => {
        LoadMessages();
    }, []);

    function toggleMenu() {
        const alertMenu = document.querySelector(".alert");
        const alertBell = document.querySelector(".alert__bell");

        if (alertMenu != null) alertMenu.classList.toggle("alert--open");

        if (alertBell != null)
            if (alertBell.classList.contains("alert__bell--new"))
                alertBell.classList.remove("alert__bell--new");
    }

    return (
        (messages.length) == 0 ? null :
            <div className={"alert" + (user!.profile.name == "approver" || user!.profile.name == "sender" ? " alert--open" : "")}>
                <span className="alert__count">{messages.length}</span>
                <div onClick={toggleMenu} className="alert__top">
                    <h2 className="alert__title">Alerts</h2>
                    <span className="alert__bell">
                        <img src={bell} alt="" />
                    </span>
                </div>

                <div className="alert__notifications">
                    <div className="alert__approved">
                        <h3 className="alert__subTitle">{messages[0].message}</h3>
                        <ul>
                            {messages.map(listMessages)}
                        </ul>
                    </div>
                </div>
            </div>
        
    );
}

export default Alert;
